import store from '@/state/store'

export default [
  {
    path: '/',
    name: 'default',
    meta: {
      authRequired: true,
    },
    component: () => {
      if (sessionStorage.getItem("userr") == 0) {
        return import('./views/dashboards/default');
      } else {
        return import('./views/dashboards/supplierHome');
      }
    }

  },
  {
    path: '/login',
    name: 'login',
    component: () => import('./views/account/login'),
    meta: {
      beforeResolve(routeTo, routeFrom, next) {
        // If the user is already logged in
        if (store.getters['auth/loggedIn']) {
          // Redirect to the home page instead
          next({ name: 'default' })
        } else {
          // Continue to the login page
          next()
        }
      },
    },
  },
  {
    path: '/logout',
    name: 'logout',
    meta: {
      authRequired: true,
      beforeResolve(routeTo, routeFrom, next) {
        store.dispatch('auth/logOut')
        const authRequiredOnPreviousRoute = routeFrom.matched.some(
          (route) => route.push('/login')
        )

        // Navigate back to previous page, or home as a fallback
        next(authRequiredOnPreviousRoute ? { name: 'default' } : { ...routeFrom })
      },
    },
  },

  // Redirect any unmatched routes to the 404 page (home page). This may
  // require some server configuration to work in production:
  // https://router.vuejs.org/en/essentials/history-mode.html#example-server-configurations
  {
    path: '*',
    redirect: '/',
  },

  {
    path: '/',
    name: 'Dashboard',
    meta: { authRequired: true },
    component: () => import('./views/dashboards/default')
  },

  {
    path: '/orders/newOrder',
    name: 'Addneworder',
    meta: { authRequired: true },
    props(route) {
      return {brand: (Object) (route.query.brand), filter: (String) (route.query.filter) , isHomePageRequest: (Boolean) (route.query.isHomePageRequest),  }
    },
    component: () => import('./views/orders/newOrder')
  },

  {
    path: '/orders/list',
    name: 'Liste des Commandes',
    meta: { authRequired: true },
    component: () => import('./views/ordersMenu/index')
  },

   {
    path: '/orders/order',
    name: 'Order',
    props(route) {
      return {  orderId: (Number) (route.query.orderId) }
    },
    meta: { authRequired: true },
    component: () => import('./views/orders/order')
  },

  {
    path: '/invoices/list',
    name: 'Liste des Factures',
    meta: { authRequired: true },
    component: () => import('./views/invoices/invoicesList')
  },

  {
    path: '/profil',
    name: 'Gestion de Profile',
    meta: { authRequired: true },
    component: () => import('./views/account/profil')
  },

  {
    path: '/reporting',
    name: 'Rapports & Stats',
    meta: { authRequired: true },
    component: () => import('./views/reporting/reporting')
  },

  {
    path: '/listOfUsers',
    name: 'liste des utilisateurs',
    meta: { authRequired: true },
    component: () => import('./views/admin/listOfUsers')
  },

  {
    path: '/parameters',
    name: 'paramètres',
    meta: { authRequired: true },
    component: () => import('./views/banner-news/banners-news')
  },
]
